import { NgModule } from '@angular/core';

import { environment } from 'src/environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';

import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ServiceInterceptor } from './core/interceptors/service.interceptor';

import { Erro404Module } from './pages/erro/404/erro-404.module';
import { Erro500Module } from './pages/erro/500/erro-500.module';

import { LoginModule } from './pages/login/login.module';
import { EsqueceuSenhaModule } from './pages/esqueceu-senha/esqueceu-senha.module';

import { CookieModule } from './shared/components/cookie/cookie.module';

import { PrincipalModule } from './pages/principal/principal.module';
import { RetornoEmailModule } from './pages/retorno-email/retorno-email.module';
import { CadastroModule } from './pages/cadastro/cadastro.module';
import { LoadingModalComponent } from './shared/modals/loading-modal/loading-modal.component';
import { SimpleModalComponent } from './shared/modals/simple-modal/simple-modal.component';
import { ImageModalComponent } from './shared/modals/image-modal/image-modal.component';
import { PoliticaPrivacidadeModule } from './pages/politica-privacidade/politica-privacidade.module';
import { TermosUsoModule } from './pages/termos-uso/termos-uso.module';
import { TesteJornadasDigitaisModule } from './pages/demonstracao/teste-jornadas-digitais/teste-jornadas-digitais.module';
import { TesteCanaisContatoModule } from './pages/demonstracao/teste-canais-contato/teste-canais-contato.module';
import { TesteAssinaturaEletronicaModule } from './pages/demonstracao/teste-assinatura-eletronica/teste-assinatura-eletronica.module';
import { LandingHomeOfficeModule } from './pages/landing/home-office/landing-home-office.module';
import { LandingContatoModule } from './pages/landing/contato/landing-contato.module';
import { ApresentacaoModule } from './pages/apresentacao/apresentacao.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

@NgModule({
  declarations: [
    AppComponent,
    LoadingModalComponent,
    SimpleModalComponent,
    ImageModalComponent
  ],
  imports: [
    BrowserModule,
    NgxGoogleAnalyticsModule.forRoot(environment.analytics),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PrincipalModule,
    LoginModule,
    EsqueceuSenhaModule,
    CadastroModule,
    Erro404Module,
    Erro500Module,
    RetornoEmailModule,
    LandingHomeOfficeModule,
    LandingContatoModule,
    PoliticaPrivacidadeModule,
    TermosUsoModule,
    CookieModule,
    TesteJornadasDigitaisModule,
    TesteCanaisContatoModule,
    TesteAssinaturaEletronicaModule,
    ApresentacaoModule,
    RecaptchaV3Module,
    NgbModule,
    AppRoutingModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ServiceInterceptor, multi: true },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha },
    { provide: RECAPTCHA_LANGUAGE, useValue: 'en' }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    LoadingModalComponent,
    SimpleModalComponent,
    ImageModalComponent
  ]
})

export class AppModule { }
